"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsFalse = exports.IsTrue = exports.Xor = exports.Not = exports.Or = exports.And = void 0;
var expression_1 = require("./expression");
var datatypes_1 = require("../datatypes/datatypes");
var And = /** @class */ (function (_super) {
    __extends(And, _super);
    function And(json) {
        return _super.call(this, json) || this;
    }
    And.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = datatypes_1.ThreeValuedLogic.and).apply;
                        _c = [datatypes_1.ThreeValuedLogic];
                        return [4 /*yield*/, this.execArgs(ctx)];
                    case 1: return [2 /*return*/, _b.apply(_a, _c.concat([(_d.sent())]))];
                }
            });
        });
    };
    return And;
}(expression_1.Expression));
exports.And = And;
var Or = /** @class */ (function (_super) {
    __extends(Or, _super);
    function Or(json) {
        return _super.call(this, json) || this;
    }
    Or.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = datatypes_1.ThreeValuedLogic.or).apply;
                        _c = [datatypes_1.ThreeValuedLogic];
                        return [4 /*yield*/, this.execArgs(ctx)];
                    case 1: return [2 /*return*/, _b.apply(_a, _c.concat([(_d.sent())]))];
                }
            });
        });
    };
    return Or;
}(expression_1.Expression));
exports.Or = Or;
var Not = /** @class */ (function (_super) {
    __extends(Not, _super);
    function Not(json) {
        return _super.call(this, json) || this;
    }
    Not.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = datatypes_1.ThreeValuedLogic).not;
                        return [4 /*yield*/, this.execArgs(ctx)];
                    case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                }
            });
        });
    };
    return Not;
}(expression_1.Expression));
exports.Not = Not;
var Xor = /** @class */ (function (_super) {
    __extends(Xor, _super);
    function Xor(json) {
        return _super.call(this, json) || this;
    }
    Xor.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = datatypes_1.ThreeValuedLogic.xor).apply;
                        _c = [datatypes_1.ThreeValuedLogic];
                        return [4 /*yield*/, this.execArgs(ctx)];
                    case 1: return [2 /*return*/, _b.apply(_a, _c.concat([(_d.sent())]))];
                }
            });
        });
    };
    return Xor;
}(expression_1.Expression));
exports.Xor = Xor;
var IsTrue = /** @class */ (function (_super) {
    __extends(IsTrue, _super);
    function IsTrue(json) {
        return _super.call(this, json) || this;
    }
    IsTrue.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = true;
                        return [4 /*yield*/, this.execArgs(ctx)];
                    case 1: return [2 /*return*/, _a === (_b.sent())];
                }
            });
        });
    };
    return IsTrue;
}(expression_1.Expression));
exports.IsTrue = IsTrue;
var IsFalse = /** @class */ (function (_super) {
    __extends(IsFalse, _super);
    function IsFalse(json) {
        return _super.call(this, json) || this;
    }
    IsFalse.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = false;
                        return [4 /*yield*/, this.execArgs(ctx)];
                    case 1: return [2 /*return*/, _a === (_b.sent())];
                }
            });
        });
    };
    return IsFalse;
}(expression_1.Expression));
exports.IsFalse = IsFalse;
//# sourceMappingURL=logical.js.map